





































import { Component, Ref } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import { ModalFooter } from '@/components/molecules/ModalFooter'

interface ModalTextAreaInterface {
  value: string
  title: string
  fieldName: string
  readonly?: boolean
  limitLinefeed?: boolean
  onClickOk?: (value: string) => void
}

const defaultValue: any = {
  value: '',
  title: '',
  fieldName: '',
  readonly: false,
  limitLinefeed: false,
  okCallback: undefined
}

@Component({
  components: {
    ModalFooter
  }
})
export default class ModalTextArea extends ModalComponentBaseVue {
  @Ref()
  modalFooter!: ModalFooter

  dialog: boolean = false

  value: string = defaultValue.value

  title: string = defaultValue.title

  fieldName: string = defaultValue.fieldName

  readonly: boolean = defaultValue.readonly

  limitLinefeed: boolean = defaultValue.limitLinefeed

  okCallback?: (value: string) => void = defaultValue.okCallback

  open(params: ModalTextAreaInterface): void {
    this.value = params.value
    this.title = params.title
    this.fieldName = params.fieldName
    this.readonly = params?.readonly ?? defaultValue.readonly
    this.limitLinefeed = params?.limitLinefeed ?? defaultValue.limitLinefeed
    this.okCallback = params?.onClickOk ?? defaultValue.okCallback

    this.dialog = true
  }

  ok(): void {
    if (this.okCallback) {
      this.okCallback(this.value)
    }

    this.close()
  }

  close(): void {
    this.dialog = false

    this.value = defaultValue.value
    this.title = defaultValue.title
    this.fieldName = defaultValue.fieldName
    this.readonly = defaultValue.readonly
    this.limitLinefeed = defaultValue.limitLinefeed
    this.okCallback = defaultValue.okCallback
  }
}
